import { cn } from '../../lib/utils';
import { dayNumber } from './helpers';
import type { DayFill, DayMark, ISODate } from './types';

type Props = {
  iso: ISODate;
  fill: DayFill;
  ring: boolean;
  today: boolean;
  disabled?: boolean;
  marked?: DayMark | null;
  onSelect: (iso: ISODate) => void;
};

export function DayButton({ iso, fill, ring, today, disabled, marked, onSelect }: Props) {
  return (
    <button
      type="button"
      disabled={disabled}
      data-testid={`calendar-day-${iso}`}
      onClick={() => onSelect(iso)}
      className={cn(
        'relative flex size-8 items-center justify-center rounded-md text-sm tabular-nums text-control-foreground transition-colors',
        !fill && !disabled && 'cursor-pointer hover:bg-control-hover',
        fill === 'mid' && 'bg-date-range',
        fill === 'edge' && 'bg-date-selected font-medium text-date-selected-foreground',
        ring && 'ring-1 ring-inset ring-date-selected',
        today && !fill && 'font-semibold',
        disabled && 'cursor-not-allowed text-control-disabled-foreground',
      )}
    >
      {dayNumber(iso)}
      {marked && (
        <span
          data-testid={`calendar-day-marked-${iso}`}
          className={cn(
            'absolute bottom-0.5 size-1 rounded-full',
            marked === 'attention' ? 'bg-notif-icon-warning' : 'bg-success',
          )}
        />
      )}
    </button>
  );
}
